import { render, staticRenderFns } from "./JBProposalSumInsured.vue?vue&type=template&id=ba1198b4"
import script from "./JBProposalSumInsured.vue?vue&type=script&lang=js"
export * from "./JBProposalSumInsured.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports